<template>
    <span>
        <v-btn icon @click="requestDeleteConfirm()">
            <v-icon>mdi-delete</v-icon>
        </v-btn>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="processConfirm" query-parameter="confirmDummyVereinDelete">
        </confirm-dialog>
    </span>
</template>

<script>
    import {db} from "../../../services/db"
    import ConfirmDialog from "../../../components/navigation/confirmDialog";
    import {firestore} from "../../../services/db";

    export default {
        components: {
            ConfirmDialog},
        name: "dummy-vereine-delete",
        props: ['item'],
        data: () => ({
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
        }),
        methods: {
            requestDeleteConfirm(){
                this.confirmDelete.header = 'Testspiel-Verein löschen';
                this.confirmDelete.question = "Möchtest du den Verein '" + this.item.name +
                    "' wirklich endgültig löschen?";
                this.confirmDelete.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.processDeletion();
                }
                this.confirmDelete.open = false;
            },
            async processDeletion(){
                this.$store.state.local.loader = true;
                const field = 'vereine.' + this.item.id;
                db.collection("landesverbaende").doc("1").update({
                    [field]: firestore.FieldValue.delete()
                })
                    .then(() => {
                        console.log("Document successfully updated!");
                        this.$store.state.local.loader = false;
                    })
                    .catch((error) => {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                        this.$store.state.local.loader = false;
                    });
            }
        },
    }

</script>

<style scoped>

</style>